import { render, staticRenderFns } from "./RelatedServiceItems.vue?vue&type=template&id=2c828c87"
import script from "./RelatedServiceItems.vue?vue&type=script&lang=ts"
export * from "./RelatedServiceItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports